import Medium from 'medium-editor'

export const meduim = {
  bind (conf) {},
  update (conf) {
    this.medium = new Medium(this.el, conf)
  }
}



// WEBPACK FOOTER //
// ./src/components/inputs/textarea/_shared/directives.js